import React, { useState } from 'react';
import { personAPI } from '../services/api';

const ImportModal = ({ onClose, onImportSuccess }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === 'application/json') {
      setFile(selectedFile);
      setError('');
    } else {
      setError('Invalid file type');
      setFile(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setError('Select a file');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await personAPI.importJSON(file);
      setSuccess(true);
      setTimeout(() => {
        onImportSuccess();
      }, 1500);
    } catch (err) {
      setError(err.response?.data?.detail || 'Import failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-tech-bg/80 backdrop-blur-sm flex items-center justify-center p-4 z-50 animate-fade-in">
      <div className="tech-card p-6 max-w-md w-full">
        <div className="flex items-center justify-between mb-6">
          <div>
            <span className="tech-section-title">DATA IMPORT</span>
            <h3 className="text-lg font-mono font-semibold text-tech-text mt-1">IMPORT JSON</h3>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-tech-textMuted hover:text-tech-text hover:bg-tech-surface rounded transition"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <div className="p-3 bg-tech-danger/10 border border-tech-danger/30 rounded text-tech-danger text-sm font-mono flex items-center gap-2">
              <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>{error}</span>
            </div>
          )}

          {success && (
            <div className="p-3 bg-tech-success/10 border border-tech-success/30 rounded text-tech-success text-sm font-mono flex items-center gap-2">
              <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              <span>Import successful</span>
            </div>
          )}

          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-3">
              SELECT FILE
            </label>
            <div className="border border-dashed border-tech-border rounded p-6 text-center hover:border-tech-accent/50 transition cursor-pointer"
              onClick={() => document.getElementById('file-upload').click()}
            >
              <input
                type="file"
                accept=".json"
                onChange={handleFileChange}
                className="hidden"
                id="file-upload"
              />
              <svg className="w-10 h-10 text-tech-textMuted mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
              </svg>
              <p className="text-sm text-tech-textMuted font-mono">
                {file ? file.name : 'CLICK OR DROP FILE'}
              </p>
              <p className="text-tech-textDim text-xs mt-1">JSON ONLY</p>
            </div>
          </div>

          <div className="bg-tech-surface border border-tech-border rounded p-4">
            <p className="text-tech-textMuted text-xs font-mono mb-2">EXPECTED FORMAT:</p>
            <pre className="text-tech-textDim text-xs font-mono overflow-x-auto">{`{
  "name": "John",
  "nickname": "JD",
  "email": "...",
  ...
}`}</pre>
          </div>

          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 tech-btn-secondary py-2"
            >
              CLOSE
            </button>
            <button
              type="submit"
              disabled={loading || !file || success}
              className="flex-1 tech-btn-primary py-2 disabled:opacity-50"
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                  </svg>
                  IMPORTING
                </span>
              ) : success ? (
                <span>DONE</span>
              ) : (
                <span>IMPORT</span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ImportModal;
